module.exports = __webpack_public_path__ + "static/media/story_mm.bfe599c6.png";